import { Button, Flexed } from '../../styles/GlobalComponents';
import { Icon, IconFlipme } from '../../styles/Icons';
import { color } from '../../styles/GlobalStyles';
import { P2 } from '../../styles/FontStyles';

import { DASHBOARD } from '../../routes/routes';
import { useHistory } from 'react-router';
import { getMyHubsPayment } from '../Portfolio/Portfolio.actions';
import { useDispatch } from 'react-redux';
import { Dispatch, SetStateAction } from 'react';
import { flipMeGetInfo } from './FlipMeWallet.actions';

interface Step3Props {
  setIsOpen: any;
}

export const Step3 = ({ setIsOpen }: Step3Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <>
      <Flexed column center>
        <Icon>
          <IconFlipme />
        </Icon>

        <P2 color={color.colors.neutral500} caps bold mt='30' mb='30'>
          One last step to complete your connection.
        </P2>
      </Flexed>
      <P2 mb='30' center bold>
        Open the FlipMe app on your device and confirm the connection request.
        Once approved, you’ll be able to access your assets and start spending.
      </P2>

      <Button
        onClick={() => {
          setIsOpen(false);
          dispatch(getMyHubsPayment());
          dispatch(flipMeGetInfo());
          history.push(DASHBOARD);
        }}>
        Back to Dashboard
      </Button>
    </>
  );
};
